
import { defineComponent, computed } from 'vue'
import { useStore } from 'vuex'
import { FieldStructure } from '@/contracts/forms/FieldContracts'

export default defineComponent(
{
    name: 'ErrorSummary',
    setup()
    {
        // Load vuex:
        const store = useStore()
        // Computed state params:
        const formErrorsExist = computed(() =>
        {
            return store.getters['errors/formErrorsExist']
        })
        const formErrorData = computed(() =>
        {
            return store.getters['errors/formErrorData']
        })
        const nuxeoErrorData = computed(() =>
        {
            return store.getters['errors/nuxeoErrorData']
        })
        // Return anchor:
        const errorAnchor = (field: FieldStructure): string =>
        {
            return '#' + field.name + '-field-group'
        }
        const nuxeoErrorAnchor = (field: string): string =>
        {
            return '#' + field + '-field-group'
        }

        // Return data:
        return {
            formErrorsExist,
            formErrorData,
            nuxeoErrorData,
            errorAnchor,
            nuxeoErrorAnchor
        }
    }
})
